module.exports = __webpack_public_path__ + "static/media/quegudan.7e5c27a1.png";